import React from "react";
import { Container, Row, Col } from "react-bootstrap";

// Images (adjust paths)
import Logo from "../Assets/03/Logo.svg";
import LinkedinIcon from "../Assets/img/linkdin.svg";
import InstagramIcon from "../Assets/img/instagram.svg";
import FacebookIcon from "../Assets/img/facebook.svg";
import WhatsappIcon from "../Assets/img/whatsapp.svg";
import IndiaFlag from "../Assets/img/flag (1) 2.svg";
import UAEFlag from "../Assets/img/united-arab-emirates (1) 1.svg";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Footer = () => {
  return (
    <footer className="footer-section pt-2 pb-3">
      <Container>
        <Row>
          {/* Logo and About */}
          <Col md={4} xs={12} className="mb-4">
            <div className="logo-container mb-3" style={{ marginTop: "20px" }}>
              <Link to="/">
                <img src={Logo} height="80" alt="Logo" />
              </Link>
            </div>
            <p>
              AnaxisTech offers scalable recruitment solutions across
              industries, connecting you with vetted, high-performing talent.
              From full-time to project-based roles, we help you build teams
              that drive growth.
            </p>
            <div className="d-flex my-3 social-icons">
              <ul className="list-unstyled d-flex justify-content-md-end justify-content-start mb-0 social_icons">
               <li>
                  <Link
                    to="https://www.linkedin.com/company/anaxisrecruit/"
                    target="_blank"
                  >
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.instagram.com/anaxisrecruit/"
                    target="_blank"
                  >
                    <img src={InstagramIcon} alt="Instagram" />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.facebook.com/AnaxisRecruit"
                    target="_blank"
                  >
                    <img src={FacebookIcon} alt="Facebook" />
                  </Link>
                </li>
                <li>
                  <Link to="https://wa.me/919023148808" target="_blank">
                    <img src={WhatsappIcon} alt="Whatsapp" />
                  </Link>
                </li>
              </ul>
            </div>
            <Link to="/contact-us">
              <button className="btn-request">Request a Quote</button>
            </Link>
          </Col>

          {/* Services */}
          <Col md={4} xs={12} className="mb-4 mt-4">
            <h5 className="mb-3 fw-semibold ">Services</h5>
            <div className="footer-services" role="list">
              <HashLink to="/service#recruitment" smooth className="d-block ">
                Recruitment
              </HashLink>
              <small>
                Fast, smart hiring that connects talent to opportunity.
              </small>
              <hr />

              <HashLink
                to="/service#recruitment-process-outsourcing"
                smooth
                className="d-block "
              >
                Recruitment Outsourcing
              </HashLink>
              <small>Seamless hiring support, handled by our experts.</small>
              <hr />

              <HashLink
                to="/service#international-recruitment"
                className="d-block "
              >
                International Recruitment
              </HashLink>
              <small>Global reach united with local expertise.</small>
              <hr />

              <HashLink
                to="/service#complete-hr-solutions"
                className="d-block "
              >
                Complete HR Solutions
              </HashLink>
              <small>End-to-end HR support tailored to your business.</small>
              <hr />
            </div>
          </Col>

          {/* Contact */}
          <Col md={4} xs={12}>
            <div className="contact-info">
              <div className="contect">
                <h5 className="mb-3 fw-semibold ">Get In Touch</h5>
                <div className="contact-box">
                  <strong>Address :</strong>
                  <div className="d-flex align-items-center gap-2 mt-2 text-center justify-content-center">
                    <img src={IndiaFlag} alt="India Flag" style={{ width: "24px", height: "24px" }} />
                    <p className="mb-0">
                      Anaxis House, Makarba Road, Ahmedabad, 380058
                    </p>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-2">
                    <img src={UAEFlag} alt="UAE Flag" style={{ width: "24px", height: "24px" }} />
                    <p className="mb-0">
                      776 DMCC Jewellery And Gemplex 3 Dubai, UAE.
                    </p>
                  </div>

                  <hr />
                  <div>
                    <strong>Call Us On:</strong>
                    <p>
                      <Link to="tel:+919023148808" className="">
                        +91 9023148808
                      </Link>
                    </p>
                  </div>
                  <hr />

                  <div>
                    <strong>Email:</strong>
                    <p>
                      <Link to="mailto:info@anaxistech.com" className="">
                        info@anaxistech.com
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Footer Links */}
        <div className="footer-links d-flex flex-wrap align-items-center gap-3 mt-4">
          <strong>Useful Links</strong>
          <Link
            to="/about"
            style={{
              textDecoration: 'none',
              color: 'inherit',
            }}
            onMouseEnter={(e) => (e.target.style.color = '#7f00c3')}
            onMouseLeave={(e) => (e.target.style.color = 'inherit')}
          >
            About Us
          </Link>
          <Link
            to="/service"
            style={{
              textDecoration: 'none',
              color: 'inherit',
            }}
            onMouseEnter={(e) => (e.target.style.color = '#7f00c3')}
            onMouseLeave={(e) => (e.target.style.color = 'inherit')}
          >
            Services
          </Link>
          <Link
            to="/candidates"
            style={{
              textDecoration: 'none',
              color: 'inherit',
            }}
            onMouseEnter={(e) => (e.target.style.color = '#7f00c3')}
            onMouseLeave={(e) => (e.target.style.color = 'inherit')}
          >
            Candidates
          </Link>
          <Link
            to="/employers"
            style={{
              textDecoration: 'none',
              color: 'inherit',
            }}
            onMouseEnter={(e) => (e.target.style.color = '#7f00c3')}
            onMouseLeave={(e) => (e.target.style.color = 'inherit')}
          >
            For Employers
          </Link>
        </div>


        {/* Copyright */}
        <div className="footer-bottom mt-4 text-center">
          © Copyright. 2025 AnaxisTech LLP. All rights reserved.
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
